import React, {Component} from 'react';

export const Panel = ({ children }) => {

    return (
        <div className="d-flex c-flex-1 justify-content-end align-items-center">
            {children}
        </div>
    );
}